export const pagesWorkScheduleEn = {
  alerts: {
    action: {
      openSchedule: 'Open schedule'
    },
    allDay: 'All day',
    categories: {
      all: 'All',
      labor_cost_over: 'Labor cost over budget',
      overtime_over: 'Overtime over budget',
      understaffed: 'Understaffed',
      unqualified_sales_risk: 'Unqualified sales risk'
    },
    columns: {
      actions: 'Actions',
      alert: 'Alert',
      date: 'Date',
      status: 'Status',
      store: 'Store',
      target: 'Target'
    },
    status: {
      open: 'Open',
      requested: 'Support requested',
      resolved: 'Resolved'
    },
    timeWindow: '{{start}}:00-{{end}}:00',
    toolbar: {
      searchPlaceholder: 'Search store or message'
    }
  },
  employeeSchedule: {
    backToLookup: 'Back to Inquiry & Reference',
    display: {
      calendar: 'Calendar',
      table: 'Table'
    },
    documentTitle: 'Work Schedule',
    empty: 'No shifts are scheduled for this month.',
    list: {
      breakMinutes: 'Break {{minutes}} min',
      noBreak: 'No break',
      title: 'Shifts this month'
    },
    summary: {
      location: 'Workplace',
      monthHours: 'Scheduled hours',
      monthShifts: 'Scheduled work days this month',
      nextShift: 'Next shift',
      noUpcoming: 'No upcoming shifts',
      unitDays: 'days',
      unitHours: 'h'
    },
    table: {
      columns: {
        break: 'Break',
        date: 'Date',
        position: 'Position',
        time: 'Hours'
      }
    },
    viewPdf: 'View PDF'
  },
  header: {
    delete: 'Delete',
    edit: 'Edit',
    menu: 'More actions',
    print: 'Print'
  },
  pageTitle: 'Work schedules & shifts',
  shifts: {
    budgetBar: {
      rate: 'Usage',
      spent: 'Actual',
      title: 'Labor budget',
      total: 'Budget'
    },
    detail: {
      back: 'Back to list',
      loading: 'Loading…',
      notFound: 'Store not found.'
    },
    dow: {
      fri: 'Fri',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thu: 'Thu',
      tue: 'Tue',
      wed: 'Wed'
    },
    editor: {
      break: 'Break',
      breakNone: 'None',
      breakUnit: 'min',
      cancel: 'Cancel',
      date: 'Date',
      delete: 'Delete',
      description: 'Enter the shift details.',
      employee: 'Employee',
      end: 'End',
      note: 'Note',
      notePlaceholder: 'Enter a note',
      position: 'Position',
      requiredBreak: 'Required break (auto)',
      save: 'Save',
      savedDesc: "Updated {{name}}'s shift.",
      savedTitle: 'Shift saved',
      start: 'Start',
      title: 'Edit shift'
    },
    filters: {
      clearFilter: 'Clear filter',
      collapse: 'Collapse',
      display: 'Display',
      employees: 'Employees',
      expand: 'Filters',
      groupByPosition: 'Group by shift category',
      hideBackground: 'Hide background shifts',
      hideOpen: 'Hide open shifts',
      location: 'Place',
      locationHq: 'Head office',
      places: {
        chiba: 'Chiba',
        ginza: 'Ginza',
        hq: 'Head office',
        ikebukuro: 'Ikebukuro',
        kawasaki: 'Kawasaki',
        kichijoji: 'Kichijoji',
        machida: 'Machida',
        omiya: 'Omiya',
        shibuya: 'Shibuya',
        shinjuku: 'Shinjuku',
        tachikawa: 'Tachikawa',
        yokohama: 'Yokohama'
      },
      shiftCategory: 'Shift category',
      showAlerts: 'Show alerts',
      showBudget: 'Show budget'
    },
    grid: {
      addPerson: 'Add member',
      alertCount: '{{count}} alert(s)',
      allEmployees: 'All employees',
      nameSort: 'Name (A-Z)',
      newMember: 'New member',
      openHours: 'Open hours',
      overLimit: 'Exceeds the weekly legal limit (40h)',
      total: 'Total'
    },
    list: {
      alertTypeLine: '{{label}}: {{count}}',
      banner: {
        title: '{{count}} shift alert(s)'
      },
      columns: {
        fillRate: 'Staffing fill rate',
        labor: 'Labor budget usage',
        manHours: 'Total labor hours',
        qualifiedCoverage: 'Licensed coverage',
        staff: 'People',
        unit: 'Unit'
      },
      criticalCount: 'Critical {{count}}',
      hours: '{{count}}h',
      noAlerts: '—',
      openSchedule: 'Open schedule',
      staffCount: '{{count}}',
      storeCount: '{{count}} stores',
      unitLabel: 'View',
      viewStores: 'View stores',
      warningCount: 'Warning {{count}}'
    },
    monthly: {
      autoGenerate: 'Auto-generate month',
      autoGenerated: 'Monthly shifts generated',
      clear: 'Clear',
      cleared: 'Monthly shifts cleared',
      risk: 'Risk',
      shifts: '{{count}} shifts'
    },
    positions: {
      cashier: 'Cashier',
      cosmetics: 'Cosmetics',
      pharmacist: 'Pharmacist',
      registeredSeller: 'Registered seller',
      stocker: 'Stocker'
    },
    print: {
      cancel: 'Cancel',
      description: 'Choose your print settings.',
      landscape: 'Landscape',
      orientation: 'Orientation',
      portrait: 'Portrait',
      print: 'Print',
      title: 'Print'
    },
    risk: {
      bannerDesc: 'No pharmacist or registered seller is scheduled during {{window}}, so OTC medicines cannot be sold.',
      bannerTitle: 'Unlicensed-sales risk',
      legend: 'Alert',
      qualified: 'Medicine license',
      requestSupport: 'Request support'
    },
    shiftAlerts: {
      types: {
        labor_cost_over: 'Labor budget over',
        overtime_over: 'Overtime budget over',
        understaffed: 'Understaffed',
        unqualified_sales_risk: 'Unlicensed-sales risk'
      }
    },
    support: {
      cancel: 'Cancel',
      description: 'Request help coverage from a nearby store.',
      ikebukuro: 'Ikebukuro',
      note: 'Note',
      notePlaceholder: 'Enter request details',
      position: 'Position',
      shibuya: 'Shibuya',
      shinjuku: 'Shinjuku',
      store: 'Support store',
      submit: 'Send request',
      submittedDesc: 'Requested support from {{store}}.',
      submittedTitle: 'Support request sent',
      time: 'Time slot',
      title: 'Request support shift'
    },
    toast: {
      confirmedDesc: 'It has been published to employees.',
      confirmedTitle: 'Schedule confirmed',
      copied: 'Duplicated',
      printing: 'Preparing to print',
      savedDesc: 'The schedule was saved as a draft.',
      savedTitle: 'Draft saved'
    },
    toolbar: {
      confirm: 'Confirm',
      copy: 'Duplicate',
      filter: 'Filter',
      more: 'More',
      next: 'Next',
      nextMonth: 'Next month',
      prev: 'Previous',
      prevMonth: 'Previous month',
      saveDraft: 'Save draft',
      searchPlaceholder: 'Search employees',
      selectPeriod: 'Select year and month',
      today: 'Today'
    },
    unitToggle: {
      orgUnit: 'Org unit',
      place: 'Place'
    },
    views: {
      daily: 'Daily',
      monthly: 'Monthly',
      weekly: 'Weekly'
    }
  },
  tabs: {
    alerts: 'Alerts',
    operationActivity: 'Operation activity',
    overview: 'Overview',
    ruleAndPolicy: 'Rule & Policy',
    settings: 'Settings',
    workSchedule: 'Work Schedule'
  }
};